var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoostSkinRadiance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.968,
    height: 85.396,
    viewBox: "0 0 81.968 85.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19397.195 19287.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.571,51.052c-.105.446-.439.544-1.743,1.45a4.777,4.777,0,0,1-4.9,0c-1.3-.906-1.639-1-1.743-1.45",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.147,37.4a3.322,3.322,0,0,1,4.089.022,7.966,7.966,0,0,0,3.406,1.742,8.333,8.333,0,0,0,2.681.141,19.654,19.654,0,0,0,3.529-.847c.833-.234,1.532-.434,2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.432,40.653a3.19,3.19,0,0,1,2.507-1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.428,37.4a3.322,3.322,0,0,0-4.089.022,7.966,7.966,0,0,1-3.406,1.742,8.333,8.333,0,0,1-2.681.141,19.654,19.654,0,0,1-3.529-.847c-.833-.234-1.532-.434-2.041-.58",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.636,38.959a3.19,3.19,0,0,1,2.507,1.694",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.129,19.283c.2,6.293-.736,30.857.679,36.191,2.482,9.324,13.7,18.48,20.754,23.456a9.984,9.984,0,0,0,11.674,0c2.172-1.53,4.737-3.458,7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.4,33.683c-.2,6.293.736,16.457-.679,21.791-2.482,9.324-13.7,18.48-20.754,23.456a9.987,9.987,0,0,1-11.674,0c-2.172-1.53-4.737-3.458-7.319-5.663",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.8,29.741a8.669,8.669,0,0,0-5.187-2.767,28.444,28.444,0,0,0-8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.867,29.7a8.669,8.669,0,0,1,5.187-2.767,28.444,28.444,0,0,1,8.127,0",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.247,5.618A165.335,165.335,0,0,1,501.863,16.48c10.5,9.683,18.069,23.972,24.264,41.646",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 12.251,
    x2: 23.059,
    transform: "translate(-19383.871 -19281.293)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.228,
    x2: 8.049,
    transform: "translate(-19356.752 -19285.936)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.073,
    x2: 7.662,
    transform: "translate(-19344.096 -19275.781)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.283,
    x2: 3.201,
    transform: "translate(-19329.334 -19255.77)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 1.812,
    x2: 4.518,
    transform: "translate(-19333.281 -19262.564)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.718,
    x2: 1.792,
    transform: "translate(-19325.516 -19249.236)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.877,
    x2: 2.188,
    transform: "translate(-19323.488 -19242.734)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.505,
    x2: 1.26,
    transform: "translate(-19320.777 -19236.463)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.255,
    x2: 5.624,
    transform: "translate(-19337.813 -19269.58)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.265,
    x2: 8.143,
    transform: "translate(-19348.936 -19281.619)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.561,65.3a1.374,1.374,0,0,1-.331-.064c.029-.04.043-.062.043-.062l-.2,0c-1.614-.708-2.965-4.189-3.942-4.565a7.888,7.888,0,0,0-2.32.392c-.392.114-1.8-.621-2.14-.441-.663.347-1.144,1.487-1.618,2.565a5.858,5.858,0,0,1-1.824,2.217h-.016l.006.007c-.1.071.15.174.15.174.827,1.014,2.182,3.284,6,3.166,3.239-.1,5.35-2.754,5.806-3.384Z",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.009,25.125c-1.136,3.689-6.322,7.343-6.322,14.176s1.547,8.7,5.074,8.7",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.254,43.435c-.572,3.063-1.9,3.065-3.278,3.065a1.5,1.5,0,0,0,0,3c2.414,0,3.976-.8,4.97-2.221q-.829-1.958-1.692-3.844",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.929,30.983V15.563l1.657-1.078L479.4,3.425",
    transform: "translate(-19845 -19288.324)",
    fill: "none",
    stroke: "#a64daa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6,11.633l.737,1.936,1.936.737-1.82.328-.328,1.82-.737-1.936-1.936-.737,1.82-.328Zm-.345-3.718-.639,3.54-.2,1.137-1.137.2-3.54.639,3.362,1.28,1.517.577.577,1.517,1.28,3.362.639-3.54.2-1.137,1.137-.2,3.54-.639-3.362-1.28-1.517-.577-.577-1.517Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.542,73.887l1.226,3.3,3.3,1.226-3.121.595-.594,3.12-1.225-3.3-3.3-1.226,3.12-.6Zm-.311-3.708L520.56,73.7l-.467,2.451-2.452.468-3.521.671,3.359,1.248,2.87,1.067,1.065,2.869,1.25,3.36.67-3.521.468-2.452,2.451-.467,3.52-.671-3.359-1.249-2.869-1.066-1.066-2.869Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.007,62.565l1.257,3.783,3.783,1.257-3.669.856-.856,3.669-1.257-3.783-3.783-1.257,3.669-.856Zm-.168-3.677-.806,3.45-.715,3.063-3.063.715-3.45.805,3.362,1.118,3.307,1.1,1.1,3.307,1.118,3.362.8-3.45.715-3.063,3.063-.715,3.45-.805-3.362-1.118-3.307-1.1-1.1-3.307Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.468,68.692l.365.908.908.365-.842.131-.131.841-.365-.907-.907-.365.841-.132Zm-.427-3.745-.561,3.591-.018.12-.121.019-3.591.56,3.373,1.356.512.2.205.512,1.356,3.372.56-3.591.019-.12.12-.018,3.591-.561-3.372-1.355-.512-.206-.206-.512Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.4,48.926l.365.907.907.366-.841.13-.131.842-.365-.907-.908-.366.842-.13Zm-.428-3.746-.56,3.591-.019.121-.12.019-3.591.56,3.372,1.356.512.205.206.512,1.355,3.371.561-3.589.018-.122.12-.017,3.592-.56-3.373-1.356-.511-.207-.206-.511Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,23.029l.365.908.908.364-.842.132-.131.841-.365-.907L523.731,24l.841-.132Zm-.427-3.745-.561,3.591L523.7,23l-.12.019-3.592.56,3.373,1.356.512.2.205.512,1.356,3.373.56-3.592.019-.12.12-.019,3.592-.56-3.373-1.355-.512-.206-.206-.512Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.02,74.357l.365.908.907.365-.841.131-.131.841-.365-.907-.908-.365.842-.131Zm-.428-3.745-.56,3.591-.019.12-.12.019-3.591.56,3.372,1.356.512.2.206.512,1.355,3.373.561-3.591.018-.12.121-.019,3.591-.561L463.665,74.7l-.512-.206-.205-.512Z",
    transform: "translate(-19845 -19288.324)",
    fill: "#a64daa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostSkinRadiance);
export default __webpack_public_path__ + "static/media/boost-skin-radiance.8ad897b6.svg";
export { ForwardRef as ReactComponent };